module.exports = "<svg viewBox=\"0 0 100 100\"><path d=\"M79 31L64 16H26c-3 0-5 2-5 5v61c0 3 2 5 5 5h48c3 0 5-2 5-5V32v-1zm-12-.5c-2 0-3-1-3-3v-7l10 10h-7zM73 84H27c-2 0-3-1-3-3V22c0-2 1-3 3-3h34v9c0 3 2 5 5 5h10v47c0 2-1 4-3 4z\"/><ellipse cx=\"38\" cy=\"57\" rx=\"2.25\" ry=\"3.5\"/><ellipse cx=\"62\" cy=\"57\" rx=\"2.25\" ry=\"3.5\"/><circle cx=\"50\" cy=\"68\" r=\"4.5\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/icons/asset-library/empty-library.svg
// module id = 950
// module chunks = 0